import { Typography, styled } from '@mui/material'

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '17px',
  lineHeight: '22px',
  letterSpacing: 0.15,
  textAlign: 'center',
  color: theme.palette.common.black,
}))
